import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useQueryParam, BooleanParam } from 'use-query-params';

import { ROOT_PATH } from 'constants/routes';
import { logoutAsThunk } from 'store/auth/thunks';

export const useLogoutAs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLogoutAsQuery, setIsLogoutAsQuery] = useQueryParam('logout_as', BooleanParam);

  if (isLogoutAsQuery) {
    setIsLogoutAsQuery(undefined);
    dispatch(logoutAsThunk());
    history.push(ROOT_PATH);
  }
};
